import { render, staticRenderFns } from "./sessionlessDeclaration.vue?vue&type=template&id=099a0180"
import script from "./sessionlessDeclaration.vue?vue&type=script&lang=js"
export * from "./sessionlessDeclaration.vue?vue&type=script&lang=js"
import style0 from "./sessionlessDeclaration.vue?vue&type=style&index=0&id=099a0180&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports